import React from 'react'
import styled from 'styled-components'

import { Grid, Wrapper, Image, H, P } from '@farewill/ui'
import { screenMax } from '@farewill/ui/helpers/responsive'

import PreventOrphan from 'components/PreventOrphan'
import CallUsTodayCta from 'components/CallUsTodayCta'
import { PRODUCTS } from 'lib/products/constants'

import data from './data'

const StyledGrid = styled(Grid)`
  align-items: center;
`

const StyledImage = styled(Image)`
  max-width: 370px;

  ${screenMax.s`
    max-width: 150px;
  `}
`

const SliceAwardWinning = (): React.ReactElement => (
  <Wrapper container>
    <StyledGrid
      paddingFromM={['M', 0]}
      paddingFromL={['XL', 0]}
      maxWidth={1000}
      margin={[0, 'auto']}
    >
      <Grid.Item span={12} spanFromM={7}>
        <H size="L" tag="h2" margin={[0, 0, 'S']} decorative>
          <PreventOrphan>{data.title}</PreventOrphan>
        </H>
        <P maxWidthInColumns={6}>{data.description}</P>
        <CallUsTodayCta product={PRODUCTS.FUNERAL} />
      </Grid.Item>
      <Grid.Item
        startColumnFromM={8}
        spanFromM={5}
        paddingFromM={[0, 0, 'XXL', 'S']}
        paddingFromL={[0, 0, 'XXL', 'M']}
        centeredFromM
        startRow={1}
      >
        <StyledImage
          path={data.mobileImagePath}
          pathFromM={data.imagePath}
          width={250}
          widthFromM={340}
          widthFromL={400}
          widthFromXL={460}
          stretch
        />
      </Grid.Item>
    </StyledGrid>
  </Wrapper>
)

export default SliceAwardWinning
